import { computed } from 'vue';

export default function useRegistrationEmailVerificationFlow({
    registrationInfo,
    userLoggedIn,
    pendingContactVerification,
    pendingEmailVerificationFlow,
    isTwoFactorEmailVerificationAllowDefer,
    isProfileOnNetwork,
    profileEmail,
    form
}) {
    const hasPendingContactVerification = computed(
        () => Object.keys(pendingContactVerification.value || {}).length > 0
    );

    const isDeferredUser = computed(() => registrationInfo.value.isTwoFactorDeferred);

    const isAccountUpdateFlow = computed(
        () => userLoggedIn.value
            && !hasPendingContactVerification.value
            && pendingEmailVerificationFlow.value
    );

    const usesPostSaveVerification = computed(
        () => isDeferredUser.value || isAccountUpdateFlow.value
    );

    const verificationFlow = computed(() => {
        if (hasPendingContactVerification.value) {
            return 'pendingSaveVerification';
        }
        if (usesPostSaveVerification.value) {
            return 'postSaveVerification';
        }
        return 'registration';
    });

    const hasPreSentVerificationCode = computed(
        () => !!pendingContactVerification.value?.verificationCodeSent
    );

    const trackingFlow = computed(() => {
        if (verificationFlow.value === 'pendingSaveVerification') {
            return 'contact-information-change';
        }
        if (isAccountUpdateFlow.value) {
            return 'account-update';
        }
        if (isDeferredUser.value) {
            return 'deferred-registration';
        }
        return 'registration';
    });

    const showSkipOption = computed(() =>
        !hasPendingContactVerification.value
        && (isDeferredUser.value
            || (isAccountUpdateFlow.value
                && isTwoFactorEmailVerificationAllowDefer.value
                && isProfileOnNetwork.value))
    );

    const isUpdateEmailMode = computed(
        () => hasPendingContactVerification.value || isAccountUpdateFlow.value
    );

    const showBackButton = computed(() => verificationFlow.value !== 'postSaveVerification');

    const displayEmail = computed(() => {
        if (hasPendingContactVerification.value) {
            return pendingContactVerification.value.contactInfo.emailAddress.emailAddress;
        }
        return usesPostSaveVerification.value ? profileEmail.value : form.email;
    });

    return {
        hasPendingContactVerification,
        isDeferredUser,
        isAccountUpdateFlow,
        usesPostSaveVerification,
        verificationFlow,
        hasPreSentVerificationCode,
        trackingFlow,
        showSkipOption,
        isUpdateEmailMode,
        showBackButton,
        displayEmail
    };
}
